import { useMemo } from 'react';
import { UserResponseViewModel } from 'types/user';
import { styled, useTheme } from '@mui/material/styles';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import { drawerWidth } from 'theme/constants';
import Box from '@mui/material/Box';

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
    user: UserResponseViewModel | null;
    children: React.ReactNode;
}

export const AppBar = ({ open, user, children }: AppBarProps) => {
    const theme = useTheme();

    const styles = useMemo(
        () => ({
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        }),
        [open, user],
    );

    return <MuiAppBar sx={styles}>{children}</MuiAppBar>;
};
